const cities = [
  { name: "Sunny Isles Beach", zips: "33160" },
  { name: "Aventura", zips: "33180" },
  { name: "Bal Harbour", zips: "33154" },
  { name: "Golden Beach", zips: "33160" },
  { name: "North Miami Beach", zips: "33162" },
  { name: "Hallandale Beach", zips: "33009" },
  { name: "Surfside", zips: "33154" },
  { name: "Miami Beach", zips: "33139" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your Sunny Isles Beach condo or office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function SunnyIslesLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] pt-12 md:pt-14 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Sunny Isles Beach &amp; Greater Miami-Fort Lauderdale
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in a luxury oceanfront tower on Collins Avenue, a seasonal residence at Trump International, or anywhere between Miami Beach and Aventura, Fast Passport Center makes expedited passport processing simple — no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Sunny Isles Beach is one of the youngest and most distinctive municipalities in Miami-Dade County, incorporated in 1997 and transformed over three decades from a quiet stretch of Atlantic coastline into one of South Florida&apos;s most luxurious oceanfront communities. What was once a modest beach town known for motels and vacation cottages is now a skyline of gleaming glass condominium towers that rival anything in Miami Beach or Brickell. The city stretches just 1.78 square miles along the barrier island between the Intracoastal Waterway and the Atlantic Ocean, yet within that narrow strip it packs some of the most expensive and sought-after real estate in the United States.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Collins Avenue — also known as State Road A1A — is the spine of Sunny Isles Beach, running the entire length of the city from the Haulover Inlet Bridge in the south to the Hallandale Beach Bridge in the north. Along this corridor, names like Trump International Beach Resort, Acqualina Resort &amp; Spa, the Porsche Design Tower, and the Muse Residences signal the caliber of the community. These are not vacation rentals for most residents — they are primary residences or seasonal homes for affluent families who divide their time between South Florida, New York, Moscow, Tel Aviv, and Sao Paulo. The demographic profile is unlike almost any other U.S. city: a remarkable concentration of Russian, Eastern European, Jewish, Latin American, and Canadian residents who have made Sunny Isles Beach their home base for international living.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The Russian and Eastern European community in Sunny Isles Beach is particularly distinctive. Russian-language newspapers, grocery stores, restaurants, and religious institutions line Collins Avenue and the surrounding neighborhoods. Russian-speaking real estate agents, attorneys, and financial advisors serve a clientele that treats Sunny Isles as a permanent base rather than a seasonal destination. For these families, travel to Moscow, St. Petersburg, Kiev, or Tashkent is not an exotic vacation — it is a visit to parents, siblings, and extended family that happens multiple times per year. Business relationships in Eastern Europe require regular face-to-face meetings, and cultural events — weddings, funerals, graduations, religious holidays — create predictable but urgent travel cycles.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Sunny Isles Beach&apos;s Jewish community is equally significant and internationally connected. Synagogues and kosher establishments serve a population that maintains deep ties to Israel, where family visits, bar and bat mitzvah celebrations, and religious pilgrimages create regular travel demand. The city&apos;s proximity to Aventura — home to one of the largest Jewish communities in the southeastern United States — means that Sunny Isles residents share cultural institutions, social networks, and travel patterns with their northern neighbors. Many families plan annual trips to Israel that are as routine as other families plan trips to Orlando.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The Latin American presence in Sunny Isles Beach is robust and growing. Colombian, Venezuelan, Brazilian, and Argentine residents have been drawn to the city&apos;s luxury lifestyle, favorable tax environment, and easy access to Latin American business capitals. For these residents, quarterly trips to Bogota, Caracas, Sao Paulo, or Buenos Aires are standard operating procedure. The city&apos;s location — roughly 20 minutes from Fort Lauderdale-Hollywood International Airport (FLL) and 30 minutes from Miami International Airport (MIA) — means that choosing a flight is often a matter of which airport offers the better direct connection, not a question of convenience.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What makes Sunny Isles Beach unique from a passport services perspective is the convergence of three factors: an extraordinarily internationally oriented population, very frequent travel to destinations with strict passport validity requirements (Russia, Israel, most of Latin America, and the Schengen Area in Europe), and a luxury lifestyle where spontaneous travel is common. A resident might decide on a Wednesday to join friends in the South of France for the weekend, book a flight from FLL through JFK on Thursday, and need a valid passport to board on Friday. A business owner might receive an unexpected opportunity to close a deal in Moscow and need to travel within a week. A grandmother might learn that a grandchild is being born in Tel Aviv and need to be there within days.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for Sunny Isles Beach travelers across every one of these scenarios. We understand that in this city, international travel is not a luxury — it is the fabric of daily life. Our courier-based expedited service means you start online from your oceanfront condo, your office on Collins Avenue, or your yacht club — and your passport arrives within days, not months. No need to drive to a passport agency in Miami. No need to wait in line. No need to hope that an appointment opens up. Just a secure online process, professional document review, and predictable results.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex flex-col xl:flex-row gap-6">
                <div className="flex-1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Sunny Isles Beach — approximately 45 miles north on I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Miami-Dade and Broward Counties</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

                {/* Map */}
                <div className="xl:w-[340px] flex-shrink-0">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '260px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=401+W+Atlantic+Ave+%23351,+Delray+Beach,+FL+33444&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Delray Beach Office Location"
                      aria-label="Google Map showing Fast Passport Center Delray Beach office at 401 W Atlantic Ave Suite 351"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    401 W Atlantic Ave #351, Delray Beach, FL 33444
                  </p>
                </div>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Miami-Dade and Broward Counties — start online, ship overnight, and we handle the rest. No need to drive to a passport agency.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Miami", href: "/miami" },
                  { name: "Aventura", href: "/aventura" },
                  { name: "Hollywood", href: "/hollywood" },
                  { name: "Fort Lauderdale", href: "/fort-lauderdale" },
                  { name: "Boca Raton", href: "/boca-raton" },
                  { name: "Palm Beach", href: "/palm-beach" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}